import PropTypes from 'prop-types';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';

/**
 * NoteSaveIndicator Component
 * 
 * Displays status information about the note saving process
 * 
 * @param {string|null} error - Error message to display, if any
 * @param {Function} onErrorClear - Handler for clearing the error
 * @returns {JSX.Element} - The rendered component
 */
const NoteSaveIndicator = ({ 
  error, 
  onErrorClear 
}) => {
  if (!error) return null;
  
  return (
    <Box mb={2}>
      <Alert 
        severity="error" 
        onClose={onErrorClear}
        variant="outlined"
      >
        {error}
      </Alert>
    </Box>
  );
};

NoteSaveIndicator.propTypes = {
  error: PropTypes.string,
  onErrorClear: PropTypes.func.isRequired,
};

NoteSaveIndicator.defaultProps = {
  error: null,
};

export default NoteSaveIndicator;
